import WithRender from "../../templates/base/pageOption.html";
import { mapGetters, mapActions } from "vuex";

export default WithRender({
  computed: {
    ...mapGetters([
      "getPageAttributesInPageOptions",
      "getActivePageOptions",
      "getShowTooltipsInPOHeader",
      "getChecked",
      "getCheckedIsNext",
      "getIsShowCheckedPageOptionFlag",
      "getIsCheckedPageOptionActive"
    ]),

    name: function () {
      return this.propsData.label;
    },
    tooltip: function () {
      return this.getShowTooltipsInPOHeader && this.propsData.tooltip;
    },
    checked: function () {
      return this.getChecked(this.index);
    },
    getDisabledClass: function () {
      if (!this.getIsCheckedPageOptionActive) {
        return "";
      }
      return this.checked || this.getCheckedIsNext(this.index)
        ? ""
        : "disabled";
    }
  },

  methods: {
    ...mapActions(["setActiveProductPageOption"]),
    onClickSelectPageOption(option) {
      this.setActiveProductPageOption(option);
    },
    activeClass: function () {
      return this.getActivePageOptions == this.code ? "active" : "";
    }
  },
  props: ["propsData", "index", "code"]
});
